export class SessionKeys {
  static readonly NEXUS_SESSION_CODEVERIFIER = 'NexusSessionCodeVerifier';
  static readonly NEXUS_SESSION = 'NexusSession';
  static readonly HIDE_PIN = 'HidePin';
}
